import { useCallback } from "react";
import useSWR from "swr";
import { useApi } from "./api";
import { CustomError } from "./errors";
import { AppVisitStatistics, ForPeriod, ModuleUsageStatistics, UsageStatisticsPeriod } from "./types/usageStatistics";

const statisticsUrl = (url: string, { from, to }: UsageStatisticsPeriod) =>
  `${url}?${new URLSearchParams({ from, to }).toString()}`;

export const useUsageStatisticsApi = () => {
  const api = useApi();

  // keepPreviousData: changing the period keeps the previous chart until the new one is loaded.
  const getAppStatistics = useCallback(
    (period: UsageStatisticsPeriod, signal: AbortSignal) => {
      const url = statisticsUrl("/admin/usage_statistics/apps", period);
      return useSWR<ForPeriod<AppVisitStatistics>, CustomError, string>(
        url,
        () => api.get<AppVisitStatistics>({ url, signal }).then((statistics) => ({ ...statistics, period })),
        { keepPreviousData: true },
      );
    },
    [api],
  );

  const getModuleStatistics = useCallback(
    (period: UsageStatisticsPeriod, signal: AbortSignal) => {
      const url = statisticsUrl("/admin/usage_statistics/modules", period);
      return useSWR<ForPeriod<ModuleUsageStatistics>, CustomError, string>(
        url,
        () => api.get<ModuleUsageStatistics>({ url, signal }).then((statistics) => ({ ...statistics, period })),
        { keepPreviousData: true },
      );
    },
    [api],
  );

  return {
    getAppStatistics,
    getModuleStatistics,
  };
};

export default useUsageStatisticsApi;
